import React from 'react'

export const PageContext = React.createContext<any>({})
export const AppContext = React.createContext<any>({})
